export default __webpack_public_path__ + "static/2-59bace4b2be957a7d7b6dc8f345c684d.png";